import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Search from '@components/algolia-search/Search'
import { useSearchContext } from '@components/context/SearchContext'

import MegaMenu from './menu/MegaMenu'

type Props = {
  open: boolean
}

export default function SearchMenu({ open }: Props) {
  const { t } = useTranslation('revamp')
  const { searchText, setSearchText } = useSearchContext()
  const breakpoints = useBreakpoint()

  useEffect(() => {
    if (!open) {
      setSearchText('')
    }
  }, [open])

  const hitsHeight = '320px'
  const hitsPerPage = useMemo(() => (breakpoints.xl3 ? 4 : 3), [breakpoints])

  return (
    <MegaMenu open={open} forceFullHeight={searchText.length > 0} className='flex-grow'>
      <div className='flex flex-col flex-grow overflow-hidden'>
        <h2 className='hidden lg3:block text-lg mb-4'>
          <span className='font-bold text-3xl leading-mid'>{t('searchMenuText.boldPart')} </span>
          {t('searchMenuText.regularPart')}
        </h2>

        <div className='w-full flex-grow flex flex-col overflow-hidden'>
          {open && <Search hitsHeight={hitsHeight} hitsPerPage={hitsPerPage} />}
        </div>
      </div>
    </MegaMenu>
  )
}
